module.exports = {
      id: "mail-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "assets/sprite-28816f.svg#mail-usage",
      toString: function () {
        return this.url;
      }
    }